import React from 'react';

import { ContentContainer } from './IncentivesProposalModalInfo';
import { useIncentivesContext } from '../IncentivesContext';

const IncentivesProposalModalInfoCommunity = () => {
  const { selectedProposalUnit } = useIncentivesContext();

  return (
    <ContentContainer>
      <div style={{ fontFamily: 'var(--font-bold)' }}>Community</div>
      <span>{selectedProposalUnit?.community?.comunity_name}</span>
      <span
        style={{
          color: 'var(--text-secondary)',
        }}
      >
        {selectedProposalUnit?.community?.address}
      </span>
    </ContentContainer>
  );
};

export default IncentivesProposalModalInfoCommunity;
